import { render, staticRenderFns } from "./SessionReplayer.vue?vue&type=template&id=5968a634"
import script from "./SessionReplayer.vue?vue&type=script&lang=js"
export * from "./SessionReplayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports